'use client';

import { useState } from 'react';

import type { SubscriptionTier } from '@wwe-portal/entities/subscription.type';
import type { OfferDialogProps } from '@wwe-portal/ui/features/club-store/dialog/offer-dialog';
import type { MissionRewardCardProps } from '@wwe-portal/ui/features/club-store/milestone/mission-reward-card';
import { OfferCardProps } from '@wwe-portal/ui/features/offer/type';

export const useMoreDescriptionState = ({
  handleBuy,
}: {
  handleBuy: (data: {
    tier: SubscriptionTier;
    offerData: OfferCardProps;
  }) => void;
}) => {
  const [data, setData] = useState<MissionRewardCardProps | undefined>();
  const props: OfferDialogProps & {
    setMoreDescriptionData: (value: MissionRewardCardProps) => void;
  } = {
    onClose: () => {
      setData(undefined);
    },
    open: data !== undefined,
    data,
    setMoreDescriptionData: (value: MissionRewardCardProps) => {
      setData(value);
    },
    handleBuy,
  };
  return props;
};
